var map = {
	"./facebook.svg": "4ced",
	"./footer/facebook.svg": "9769",
	"./footer/linkedin.svg": "ada3",
	"./footer/youtube.svg": "71a2",
	"./google.svg": "0f56",
	"./instagram.svg": "fb1d",
	"./linkedin.svg": "7971",
	"./reddit.svg": "ca11",
	"./spotify.svg": "9f66",
	"./stackoverflow.svg": "7e87",
	"./twitter.svg": "aae3",
	"./web.svg": "cd4d",
	"./youtube.svg": "c57b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f0d4";